import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { MySettingsDTO } from './useMySettingsQuery';

const saveMySettings = async (params: MySettingsDTO) => {
  return authFetch('/Adviser/Settings/My', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });
};

export const useSaveMySettingsMutation = () => {
  return useMutation(saveMySettings);
};
